/* Primary-nav rail item. Mirrors andavo-dev's SideNavItem, but FIXED-width
   (always expanded — the unified rail does not collapse). Active state matches
   the upstream: dark-slate pill fill with inverted text. */
import type { ReactNode } from 'react';
import type { To } from 'react-router';
import { Link } from 'react-router';
import { cn } from '../util/cn';

export type SideNavItemProps = {
  icon: ReactNode;
  label: string;
  path: To;
  isActive: boolean;
  /**
   * Render as an indented CHILD entry (a subpage under an expanded parent
   * module). Slightly inset + smaller so the rail reads as a two-level tree.
   */
  nested?: boolean;
};

export function SideNavItem({
  icon,
  label,
  path,
  isActive,
  nested = false,
}: SideNavItemProps) {
  return (
    <li className="group relative">
      <Link
        to={path}
        aria-current={isActive ? 'page' : undefined}
        className={cn(
          'flex cursor-pointer items-center gap-3 rounded-full font-inter transition-all',
          nested
            ? 'h-9 py-1.5 pr-4 pl-9 text-[0.8125rem]'
            : 'h-10 px-4 py-2 text-sm',
          isActive
            ? 'bg-surface-background-dark text-content-white'
            : 'text-content-secondary hover:bg-surface-foreground hover:text-content-primary',
        )}
      >
        <span className="flex w-6 shrink-0 items-center justify-center [&>svg]:size-icon-md">
          {icon}
        </span>
        <span className="overflow-hidden whitespace-nowrap">{label}</span>
      </Link>
    </li>
  );
}
